<div class="loader" *ngIf="loading">
  <mat-spinner [diameter]="150"></mat-spinner>
</div>
<div class="card">
  <app-header></app-header>
  <div class="container">
    <div class="background" >
      <div data-test="imagem-login" class="fundo"></div>
    </div>
    <form [formGroup]="loginFormGroup" class="login-form" autocomplete="off" >
      <fieldset data-test="form-login" [disabled]="loading" class="fieldset">
        <h1 data-test="titulo-login" class="login-message">{{'signIn.loginMessage' | translate}}</h1>
        <mat-form-field class="full-input-grid" appearance="outline">
          <mat-label>{{ 'signUp.email' | translate }}</mat-label>
          <input data-test="campo-email-login" type="email" matInput formControlName="email" placeholder="Ex: example@example.com">
          <mat-error *ngIf="form['email'].invalid && !form['email'].hasError('emailExists')">{{message.errorMessage(form['email'])}}</mat-error>
          <mat-error *ngIf="form['email'].invalid && form['email'].hasError('emailExists')">{{ message.emailInUse(form['email'].value)}}</mat-error>
          <mat-icon matPrefix>perm_identity_icon</mat-icon>
        </mat-form-field>
          <!-- <mat-form-field class="full-input-grid" appearance="outline">
            <mat-label>{{ 'signUp.loginName' | translate }}</mat-label>
            <input type="text" matInput formControlName="login" placeholder="Ex: Admin">
            <mat-error *ngIf="form['login'].invalid">{{message.errorMessage(form['login'])}}</mat-error>
            <mat-icon matPrefix>perm_identity_icon</mat-icon>
          </mat-form-field> -->
          <mat-form-field data-test="div-campo-senha" class="full-input-grid senha" appearance="outline">
            <mat-label>{{ 'signUp.password' | translate }}</mat-label>
            <input data-test="campo-senha-login" [type]="hide ? 'password' : 'text'" matInput formControlName="password" maxlength="30">
            <mat-icon matSuffix (click)="hide = !hide" data-test="icone-visualizar-senha">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-error *ngIf="form['password'].invalid">
              <ul>
                {{ 'signUp.passwordValidationHeader' | translate }}
                <li>{{ 'signUp.passwordValidationFirstItem' | translate }}</li>
                <li>{{ 'signUp.passwordValidationSecondItem' | translate }}</li>
                <li>{{ 'signUp.passwordValidationThridItem' | translate }}</li>
                <li>{{ 'signUp.passwordValidationFourthItem' | translate }}</li>
                <li>{{ 'signUp.passwordValidationFifthItem' | translate }}</li>
                <br />
                {{ 'signUp.passwordValidationFooter' | translate }}
              </ul>
              <!-- {{message.errorMessage(form['password'])}} -->
            </mat-error>
            <mat-icon matPrefix>lock</mat-icon>
          </mat-form-field>
          <a class="redirect-link forgot-password" routerLink="/forgot-password" data-test="link-esqueci-senha">{{ 'signIn.forgotPassword' | translate }}</a>
          <div class="inactive-account" *ngIf="accountInactive">
            {{ inactiveMessage }}
          </div>
          <div>
            <button data-test="btn-entrar-login" class="full-input-grid button" mat-raised-button color="primary" (click)="signup()">{{ 'signIn.enterButton' | translate }}</button>
          </div>
          <a class="redirect-link register" routerLink="/sign-up" data-test="link-criar-conta">{{ 'signIn.dontHaveAccount' | translate }}</a>
        </fieldset>
      </form>
  </div>
  <span class="version">v1.16.0.0</span>
</div>